// THIS FILE IS GENERATED, DO NOT EDIT!
/* eslint-disable */
import * as Types from '@h5s/dtos-api';

import { LocalDate, LocalDateTime, LocalTime } from '@h5s/util-date';
import { gql } from 'apollo-angular';
export type SendResultFragment = { __typename?: 'SendResultDTO', error: string | null, invoiceId: number };

export const SendResultFragment = gql`
    fragment SendResult on SendResultDTO {
  error
  invoiceId
}
    `;
/* eslint-enable */